// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2Qhko","list":"styles_list__2TzWJ"};